let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6KmpS")).then(() => parcelRequire('fARTX'));